export default __webpack_public_path__ + "static/media/Bg1.077c2fe7.jpg";